import * as Updates from 'expo-updates';
import { Platform } from 'react-native';
import Constants from 'expo-constants';

let Config = {
  apiUrl: Constants.expoConfig.extra.apiUrl || 'https://192.168.1.193:4000',
  webApi: __DEV__ ? Constants.expoConfig.extra.webApi : "https://api.smartsaas.pro",
  aiAPI: __DEV__ ? (Platform.OS === 'web' ? "https://localhost:11435" : "http://192.168.1.133:11435") : "https://ai.smartsaas.pro:11437",
  aiChatAPI: __DEV__ ? (Platform.OS === 'web' ? "http://localhost:11434" : "http://192.168.1.133:11434") : "https://ai.smartsaas.pro:11436",
  enableHiddenFeatures: false,
  appStoreSecret: '35322a6bc5274befa6ca622ff79be5db'
};

if (Updates.channel === 'production') {
  Config.apiUrl = 'https://api.smartsaas.pro';
  Config.webApi = 'https://api.smartsaas.pro';
  Config.enableHiddenFeatures = false;
} else if (Updates.channel === 'staging') {
  Config.apiUrl = 'https://smartsaas-backend-staging-530616870665.us-central1.run.app';
  Config.enableHiddenFeatures = true;
}

// ✨ Configure logging based on environment
// Disables console logging in production mode, especially for web
export const configureProductionLogging = () => {
  // Check if we're in production mode
  // For web: check if not in dev mode (!__DEV__) and on web platform
  // For native: check Updates channel or !__DEV__ and not web
  const isWebProduction = Platform.OS === 'web' && !__DEV__;
  const isNativeProduction = Updates.channel === 'production' || (!__DEV__ && Platform.OS !== 'web');
  const isProduction = isWebProduction || isNativeProduction;
  
  if (isProduction) {
    const noop = () => {};
    
    // Silence all console logging methods in production
    console.log = noop;
    console.info = noop;
    console.debug = noop;
    console.trace = noop;
    console.warn = noop;
    
    // Keep console.error as noop in production (or optionally route to error tracking)
    // Uncomment the code below if you want to keep error logging for debugging
    // const originalError = console.error;
    // console.error = (...args) => {
    //   originalError(...args);
    //   // You can add crash reporting here (Sentry, Firebase, etc.)
    // };
    console.error = noop;
  }
};

export default Config;0